import React from 'react';
import { Button, ButtonProps } from '@mui/material';

import { ActionButtonProps } from './types';
import {
  AbortButton,
  AcceptButton,
  AcceptButtonBlue,
  AcceptButtonBlueLight,
  CloseButton,
  GhostButton,
  InteractionButton,
  LightAbortButton1,
  LightAbortButton2,
  LinkButton,
  SecondActionButton,
} from './styles';
import ArrowIcon from '../../../assets/icons/ArrowIcon';

const ActionButton: React.FC<
  ActionButtonProps & {
    back?: boolean | string;
    icon?: React.ReactNode;
    customComponent?: React.ComponentType<never>;
  }
> = ({
  onClickAction,
  buttonText,
  variant = 'text',
  disabled = false,
  fullWidth = false,
  back = false,
  icon,
  customComponent: CustomComponent,
}) => {
  // Convert `back` to a string if it's a boolean to prevent browser warnings
  // about non-boolean attributes in HTML
  const backString = back.toString();

  const sharedProps = {
    disabled,
    onClick: onClickAction,
    fullWidth,
    ...(back && { back: backString }),
    children: (
      <>
        {back && <ArrowIcon />}
        {icon &&
          (variant === 'interaction-button' ||
            variant === 'accept' ||
            variant === 'link-button') &&
          icon}
        {buttonText}
        {!back && variant === 'link-button' && !icon && <ArrowIcon />}
      </>
    ),
  };

  if (CustomComponent) {
    // @ts-expect-error will be fixed
    // will be fixed
    return <CustomComponent {...sharedProps} />;
  }

  switch (variant) {
    case 'accept':
      return <AcceptButton {...sharedProps} />;
    case 'cancel':
      return <SecondActionButton {...sharedProps} />;
    case 'abort':
      return <AbortButton {...sharedProps} />;
    case 'close':
      return <CloseButton {...sharedProps} />;
    case 'ghost':
      return <GhostButton {...sharedProps} />;
    case 'accept-blue':
      return <AcceptButtonBlue {...sharedProps} />;
    case 'accept-blue-light':
      return <AcceptButtonBlueLight {...sharedProps} />;
    case 'link-button':
      return <LinkButton {...sharedProps} />;
    case 'interaction-button':
      return <InteractionButton {...sharedProps} />;
    case 'light-abort-1':
      return <LightAbortButton1 {...sharedProps} />;
    case 'light-abort-2':
      return <LightAbortButton2 {...sharedProps} />;
    default:
      return (
        <Button variant={variant as ButtonProps['variant']} {...sharedProps} />
      );
  }
};

export default ActionButton;
